import styled from "styled-components";

const Section = styled.section`
  position: relative;
  height: 12rem;
  overflow: hidden;
  @media (min-width: 768px) {
    height: 14rem;
  }
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: hsl(${({ theme }) => theme.colors.navDark} / 0.7);
`;

const Inner = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  max-width: ${({ theme }) => theme.layout.shellMax};
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.layout.shellPadX};
`;

const H1 = styled.h1`
  margin: 0 0 0.25rem;
  font-size: clamp(1.75rem, 1.2rem + 2vw, 2.75rem);
  font-weight: 800;
  color: hsl(${({ theme }) => theme.colors.navDarkForeground});
`;

const P = styled.p`
  margin: 0;
  color: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.7);
  font-size: clamp(0.9375rem, 0.88rem + 0.25vw, 1.125rem);
`;

export default function CategoryDetailHero({ category }) {
  return (
    <Section>
      <Img src={category.image} alt={category.name} />
      <Overlay />
      <Inner>
        <div>
          <H1>{category.name}</H1>
          <P>{category.description}</P>
        </div>
      </Inner>
    </Section>
  );
}
